module.exports = __webpack_public_path__ + "img/zhongtong-icon.9e3027d4.png";